import { useCallback } from 'react'
import { useWallet } from '@solana/wallet-adapter-react'

const useSignMessage = () => {
  const { connected, publicKey, signMessage: _signMessage } = useWallet()

  const signMessage = useCallback(
    async (
      message: string,
      options?: {
        timeout?: number
        encoding?: BufferEncoding
        onTimeOut?: (errorMessage?: string) => void
        onError?: (errorMessage?: string) => void
      }
    ) => {
      if (!connected || !publicKey || !_signMessage) return
      const {
        timeout = 8000,
        encoding = 'hex',
        onError,
        onTimeOut
      } = options || {}
      let isTimeOut = false
      try {
        const timeoutPromise = new Promise<any>((_, reject) =>
          setTimeout(() => {
            isTimeOut = true
            reject(
              new Error(
                'Signature timed out. If the wallet popup did not appear, please close or refresh the page manually.'
              )
            )
          }, timeout)
        )
        const encodedMessage = new TextEncoder().encode(message)
        const signMessagePromise = _signMessage(encodedMessage)
        const signature = await Promise.race([
          signMessagePromise,
          timeoutPromise
        ])
        if (!signature) throw new Error('Signature cancelled')
        const decodeSignature = Buffer.from(signature).toString(encoding)
        return { signature: decodeSignature, signatureMessage: message }
      } catch (error) {
        if (isTimeOut) {
          onTimeOut?.((error as Error).message)
          return
        }
        onError?.((error as Error).message)
      }
    },
    [_signMessage, connected, publicKey]
  )

  return {
    signMessage
  }
}

export default useSignMessage
